
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.652","height":"16.652"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Union_66","data-name":"Union 66","d":"M15260.066 24718.559a.787.787 0 01-.67-.67 5.613 5.613 0 012.189-5.373.8.8 0 01.962 1.291 1.9 1.9 0 101.6 1.6.8.8 0 011.29.963 5.627 5.627 0 01-4.5 2.26 5.539 5.539 0 01-.871-.071zm6.271-2.115v-2.953a11.254 11.254 0 01-1.873-1.873h-2.953a.533.533 0 01-.533-.533 4.821 4.821 0 015.583-4.76 11.2 11.2 0 018.877-4.348.539.539 0 01.54.533 11.23 11.23 0 01-4.349 8.883 4.821 4.821 0 01-4.759 5.584.533.533 0 01-.532-.534zm2.674-9.107a1.607 1.607 0 101.606-1.607 1.608 1.608 0 00-1.605 1.606z","transform":"translate(-15259.326 -24701.977)","fill":"#fff"}})])
          )
        }
      }
    